import { ClassMembers } from '../../../server/dto/generated/ClassMembers';


import { GeneratedBizBase } from '../../../framework/frontend/GeneratedBizBase';


import { Response } from '../../../framework/biz/Response';


 // サーバーサイドコードへのリンク(このコードは実行されません)
const __non_exec_code = async () => {
  // import("../../../server/biz/ClassRoomService");
};

export class ClassRoomService extends GeneratedBizBase{
  async addNewMember(teacher_id: number,className: string): Promise<Response<ClassMembers>> {
    return super.restCall<Response<ClassMembers>>('post', '/v1/ClassRoomServices/addNew', arguments);
  }
  async getMembers(teacher_id: number): Promise<Response<ClassMembers[]>> {
    return super.restCall<Response<ClassMembers[]>>('get', '/v1/ClassRoomServices/getMembers', arguments);
  }
  async updateMember(member: ClassMembers): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/ClassRoomServices/updateMember', arguments);
  }
  async deleteMember(member: ClassMembers): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/ClassRoomServices/deleteMember', arguments);
  }
}
